import PropTypes from 'prop-types';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  DesktopOwnerFilters,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/DesktopOwnerFilters';
import {
  MobileOwnerFilters,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/MobileOwnerFilters';

const OwnerFiltersPicker = ({ onSubmit }) => {
  const isMobile = useMobileLayout();
  const { resource, handleChange: handleAttrChange } = useMetaLayoutContext();
  const [currentVal, setCurrentVal] = React.useState(resource.attr('ownerClientId'));
  const ownerOptions = resource.meta().field('ownerClientId').options().list();
  if (ownerOptions.length === 0) {
    return null;
  }

  const handleChange = async (value) => {
    setCurrentVal(value);
    handleAttrChange('ownerClientId', value ?? []);
    await onSubmit(value);
  };

  if (isMobile) {
    return (<MobileOwnerFilters handleChange={handleChange} currentVal={currentVal} ownerOptions={ownerOptions} />);
  }

  return (<DesktopOwnerFilters handleChange={handleChange} currentVal={currentVal} ownerOptions={ownerOptions} />);
};

OwnerFiltersPicker.defaultProps = {};

OwnerFiltersPicker.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export { OwnerFiltersPicker };
